
const patchNewsClientLinks = (container, language) => {
    if (!container || !language) {
        return;
    }

    container.querySelectorAll('.category__header a, .category__list a').forEach(link => {
        try {
            const url = new URL(link.href, window.location.origin);
            url.searchParams.set('language', language);
            link.href = url.toString();
        } catch (err) {
            // ignore malformed hrefs
        }
    });
};

const syncNewsClientTheme = (container) => {
    if (!container) return;

    const portalTheme = document.documentElement.getAttribute('data-bs-theme');
    const theme = portalTheme === 'dark' || portalTheme === 'black' ? 'dark' : 'light';

    container.setAttribute('data-bs-theme', theme);
    container.setAttribute('data-theme', theme);
};

// const affixTopPromise = (delayMsec) => {
//     // Deferred promise for affixTop func
//     const affixTop = (() => {
//         let resolve;
//         const promise = new Promise((res) => {
//             resolve = res;
//         });
//         return { promise, resolve };
//     })();
//
//     const oldAffix = window.affixTop;
//
//     window.affixTop = () => {
//         oldAffix();
//         affixTop.resolve('affix');
//     };
//
//     const shortDelay = (mSec) => new Promise((resolve) => {
//         setTimeout(resolve, mSec, 'delay');
//     });
//
//     return Promise.race([shortDelay(delayMsec), affixTop.promise])
//         .then((/* value */) => {
//             // console.log(value);
//             return loadNewsClient();
//         });
// };

const getNews = (params) => {
    // console.log(params)
    let hasShown = false;

    return (observer) => {
        if (hasShown) return;

        const loadNewsClient = async () => await import(
            /* webpackChunkName: "inbox-news-2026" */
            'news-client' // prod
            // '../../../../../../vendor/inbox/news-client/src/App' // dev
        );

        const getNewsModule = loadNewsClient();

        getNewsModule
            .then(({ PortalApp }) => {
                try {
                    syncNewsClientTheme(params.appContainer);
                    PortalApp(params);
                    setTimeout(() => {
                        patchNewsClientLinks(params.appContainer, params.language);
                    }, 0);
                    hasShown = true;
                    observer.unobserve(params.appContainer);
                } catch (err) {
                    console.log(err);
                }
            }).catch((err) => {
                console.log(err);
            });
    };
};

export default () => {
    const { inx } = window;
    if (!inx || !inx.newsClient) return;

    const { newsClient } = inx;
    syncNewsClientTheme(newsClient.appContainer);

    const themeObserver = new MutationObserver(() => {
        syncNewsClientTheme(newsClient.appContainer);
    });
    themeObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-bs-theme'],
    });
    const observerCallback = (entries, observer) => {
        const { isIntersecting } = entries[0];
        if (isIntersecting) {
            getNews(newsClient)(observer);
        }
    };

    const intObserver = new IntersectionObserver(observerCallback, {
        rootMargin: '0px 0px 0px 0px',
        threshold: 0.01,
    });
    intObserver.observe(newsClient.appContainer);
};
